export type FrontPaths = typeof frontPaths

export const frontPaths = {
  home: '/',
  notifications: '/notifications',
  security: {
    index: '/security',
    login: '/security/login',
    passwordRecovery: '/security/passwordRecovery'
  },
  modules: {
    sales: {
      clients: '/sales/clients',
      'service-recharge-invoices': '/sales/service-recharge-invoices',
      'weppa-flex': '/sales/weppa-flex'
    },
    collections: {
      'pending-recharges': '/collections/pending-recharges',
      'late-quotas': '/collections/late-quotas'
    },
    inventory: {
      apples: '/inventory/apples',
      products: '/inventory/products',
      automotive: '/inventory/automotive'
    },
    support: {
      'release-request': '/support/release-request',
      'client-edit-request': '/support/client-edit-request',
      'article-edit-request': '/support/article-edit-request',
      'article-change-request': '/support/article-change-request',
      'article-reassign-request': '/support/article-reassign-request',
      'article-delete-request': '/support/article-delete-request'
    },
    reports: {
      'total-sales': '/reports/total-sales',
      'sales-by-branch': '/reports/sales-by-branch',
      'sales-by-ally': '/reports/sales-by-ally',
      'automatic-payments': '/reports/automatic-payments',
      'apple-devices-overdue': '/reports/apple-devices-overdue',
      'overdue-quotas-list': '/reports/overdue-quotas-list',
      'ally-overdue-devices': '/reports/ally-overdue-devices',
      'approved-payments-by-employees':
        '/reports/approved-payments-by-employees',
      'approved-payments-to-ally': '/reports/approved-payments-to-ally',
      'recharge-by-ally': '/reports/recharge-by-ally',
      'marketplace-ally-pending-products':
        '/reports/marketplace-ally-pending-products',
      'referral-codes': '/reports/referral-codes',
      'branch-offices': '/reports/branch-offices',
      'movistar-club': '/reports/movistar-club',
      'preassigned-credit-summary': '/reports/preassigned-credit-summary',
      'credit-refinancing': '/reports/credit-refinancing',
      'weppa-plus-clients': '/reports/weppa-plus-clients',
      'zone-u': '/reports/zone-u',
      cashout: '/reports/cashout',
      geolocation: '/reports/geolocation',
      'assigned-motorcycles': '/reports/assigned-motorcycles',
      'quotes-collection': '/reports/quotes-collection',
      'cash-top-ups': '/reports/cash-top-ups'
    },
    teaching: {
      videosCategory: '/teaching/videosCategory',
      videos: '/teaching/videos',
      videoList: '/teaching/videoList'
    },
    allies: {
      allies: '/allies/allies',
      'payment-request': '/allies/payment-request',
      'daily-cut': '/allies/daily-cut',
      'monthly-cut': '/allies/monthly-cut'
    },
    services: {
      services: '/services/services',
      'daily-cut': '/services/daily-cut'
    },
    insurers: {
      'service-centers': '/insurers/service-centers',
      'rentability-configuration': '/insurers/rentability-configuration',
      claims: '/insurers/claims'
    },
    marketplace: {
      orders: '/marketplace/orders',
      marketplaces: '/marketplace/marketplaces',
      products: '/marketplace/products',
      discounts: '/marketplace/discounts',
      inventory: '/marketplace/inventory'
    },
    draw: {
      campaigns: '/draw/campaigns',
      draws: '/draw/draws'
    },
    settings: {
      users: '/settings/users',
      categories: '/settings/categories',
      brands: '/settings/brands',
      localizations: '/settings/localizations',
      tasas: '/settings/tasas',
      roles: '/settings/roles',
      imports: '/settings/imports',
      promotions: '/settings/promotions',
      paymentMethods: '/settings/paymentMethods',
      banks: '/settings/banks',
      pushNotifications: '/settings/pushNotifications',
      levels: '/settings/levels',
      publicity: '/settings/publicity'
    }
  }
} as const
